import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bPayCodeFormat',
  standalone: true
})
export class BillPayCodeFormatPipe implements PipeTransform {
  transform(value?: string | null): string {
    if (value == null || value.trim() === '') {
      return '';
    }
    if(value.length < 15) {
      return `${value.substring(0, 3)} ${value.substring(3, 6)} ${value.substring(6, 9)} ${value.substring(9, 13)}`.trim();
    }

    return `${value.substring(0, 4)} ${value.substring(4, 8)} ${value.substring(8, 12)} ${value.substring(12, 15)}`.trim();
  }
}